module.exports = __webpack_public_path__ + "img/delivery-insurance.a101a138.png";